import { PostboxDocument, getPostboxDocumentsEndpoint } from 'cpes-common';
import { getSimpleDataFetchSlice } from '@cp-shared-19/frontend-integration';
import { CpDataApi } from 'cp-xhr';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';

const { reducer, fetchData } = getSimpleDataFetchSlice<PostboxDocument[], DefaultBusinessMarketApiErrorCode>({
    dataName: 'postbox',
    fetchCallback() {
        return CpDataApi.get(getPostboxDocumentsEndpoint()).then(response => response.data);
    },
});

export default reducer;
export const fetchPostbox = fetchData;
